// extracted by mini-css-extract-plugin
module.exports = {"divider":"ModifyPromptSidebarHeader_divider__LF0Mu","header":"ModifyPromptSidebarHeader_header__Y_nS8"};